<template>
<div class="overlay centered">
    <img src="/assets/img/logo@2x.png" class="logo pulsating">
</div>
</template>
<script>
export default {
    name: 'LoadingContainer'
}
</script>
